module.exports = __webpack_public_path__ + "img/opensoft.8f9137ab.png";